export default __webpack_public_path__ + "static/media/Group 3211@2x.9f907467.png";